import { useState, useEffect, useRef } from "react";
import { Formik, Form, Field } from "formik";
import { useAuth } from "../context/AuthContext";
import Toaster, { ToastContainerComponent } from "../components/Toaster";
import FullScreenLoader from "../components/FullScreenLoader";
import { sendOtpApi } from "../utils/api";

const VerifyOtp = () => {
  const { verifyOtp } = useAuth();
  const [loading, setLoading] = useState(false);
  const [resendDisabled, setResendDisabled] = useState(false);
  const [timer, setTimer] = useState(30); // Cooldown timer for resend
  const getEmail = sessionStorage.getItem("getEmail");
  const getAction = sessionStorage.getItem("getAction");
  const hasSentOtp = useRef(false);

  // Send OTP when component mounts
  useEffect(() => {
    const sendOtp = async () => {
      if (!getEmail) {
        Toaster.error("Email not found. Please try again.");
        return;
      }
      if (hasSentOtp.current) return;
      hasSentOtp.current = true;

      setLoading(true);
      try {
        console.log("getAction",getAction);
        if(getAction != "resetPassword"){
          await sendOtpApi(getEmail, "login");
          }
      } catch (error) {
        Toaster.error(error.response?.data?.message || "Failed to send OTP.");
      } finally {
        setLoading(false);
      }
    };

    sendOtp();
  }, [getEmail]);

  // Handle OTP verification
  const handleVerifyOtp = async (values, actions) => {
    const { otp } = values;

    if (!otp) {
      Toaster.error("Please enter the OTP.");
      actions.setSubmitting(false);
      return;
    }

    setLoading(true);
    try {
      await verifyOtp(getEmail, otp);
    } catch (error) {
      const errorMsg =
        error?.response?.data?.message ||
        error?.message ||
        "OTP verification failed.";
      Toaster.error(errorMsg);
      actions.setSubmitting(false);
    } finally {
      setLoading(false);
      actions.setSubmitting(false);
    }
  };

  // Handle Resend OTP
  const handleResendOtp = async () => {
    if (resendDisabled) return; // Prevent spamming

    setResendDisabled(true);
    setTimer(30); // Reset cooldown timer

    try {
      await sendOtpApi(getEmail, "login");
      Toaster.success("OTP resent successfully.");
    } catch (error) {
      Toaster.error(error.response?.data?.message || "Failed to resend OTP.");
    }

    // Start countdown timer
    let countdown = 30;
    const interval = setInterval(() => {
      countdown -= 1;
      setTimer(countdown);
      if (countdown === 0) {
        clearInterval(interval);
        setResendDisabled(false);
      }
    }, 1000);
  };

  return (
    <>
      <FullScreenLoader loading={loading} />
      <div className="login_page">
        <ToastContainerComponent />
        <div className="login">
          <div className="login_left">
            <div className="login_box">
              <h2>Check your e-mail!!!</h2>
              <Formik initialValues={{ otp: "" }} onSubmit={handleVerifyOtp}>
                {({ isSubmitting }) => (
                  <Form className="otp_form resend_box">
                    <div className="para_heading">
                      <p>
                        We've sent a 6-digit verification code to your email{" "}
                        <strong>{getEmail}</strong>. Please enter the code to
                        log in.
                      </p>
                    </div>
                    <div className="input_field">
                      <Field
                        className="form_control"
                        type="text"
                        name="otp"
                        placeholder="Enter 6-digit OTP"
                      />
                      <span className="icon">
                        <i className="fa-solid fa-lock"></i>
                      </span>
                    </div>
                    <div className="forget_btn">
                      <button
                        type="button"
                        onClick={handleResendOtp}
                        disabled={resendDisabled}
                        className={`resend_otp_btn ${
                          resendDisabled ? "disabled" : ""
                        }`}
                      >
                        {resendDisabled
                          ? `Resend OTP in ${timer}s`
                          : "Resend OTP"}
                      </button>
                    </div>
                    <button
                      type="submit"
                      className="login_btn"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Verifying..." : "Verify OTP"}
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
          <div className="login_right">
            <div className="logo">
              <img src="./images/logo.png" alt="Logo" />
            </div>
            <h2>
              Welcome! <br /> 1st Choice Formation
            </h2>
          </div>
        </div>
      </div>
    </>
  );
};

export default VerifyOtp;
